import moment from 'moment';
import { LitEntity, renderIf, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-property';
import '../props/device-firmware-mode';
import '../props/device-sleep-time';
import '../props/device-sensor-type';

class DeviceDetails extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
        flex-wrap: wrap;
      }
      .column {
        display: flex;
        flex-direction: column;
        margin-bottom: 1em;
        margin-right: 1em;
      }
      .column * + * {
        margin-top: 1em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return;
    }

    return html`
      <div class="column">
        <bn-property stacked label="Device Id">${this.entity.properties.deviceId}</bn-property>
        ${renderIf(this.isHDDevice(), () => html`<bn-property stacked label="Serial Number">${this._orUnknown(this.entity.properties.serialNumber)}</bn-property>`)}
        <bn-property stacked label="Hardware Version">${this._orUnknown(this.entity.properties.hardwareVersion)}</bn-property>
        <bn-property stacked label="ECN">${this._orUnknown(this.entity.properties.engineeringChangeNotice)}</bn-property>
        <bn-property stacked label="Sensor Type"><device-sensor-type .href="${this.href}"></device-sensor-type></bn-property>
        ${renderIf(this.isFeedDevice(), () => html`<bn-property stacked label="External Antenna">${this._orUnknown(this.entity.properties.hasExternalAntenna)}</bn-property>`)}
      </div>

      <div class="column">
        <bn-property stacked label="Firmware Version">${this._orUnknown(this.entity.properties.firmwareVersion)}</bn-property>
        ${renderIf(this.isFeedDevice(), () => html`<bn-property stacked label="ublox Version">${this._orUnknown(this.entity.properties.ubloxVersion)}</bn-property>`)}
        ${renderIf(this.isFeedDevice(), () => html`<bn-property stacked label="xbee Version">${this._orUnknown(this.entity.properties.xbeeVersion)}</bn-property>`)}
        <bn-property stacked label="iccid">${this._orUnknown(this.entity.properties.iccid)}</bn-property>
        <bn-property stacked label="imei">${this._orUnknown(this.entity.properties.imei)}</bn-property>
      </div>

      <div class="column">
        ${renderIf(this.isFeedDevice(), () => html`<bn-property stacked label="Battery Level">${this._orUnknown(this.entity.properties.batteryVoltage, 'V')}</bn-property>`)}
        ${renderIf(this.isFeedDevice(), () => html`<bn-property stacked label="Battery Version">
            <device-battery-display-name .href="${this.href}"></device-battery-display-name>
          </bn-property>`)}
        <bn-property stacked label="Factory Setup At" title=${this.entity.properties.factorySetupAt}>${moment(this.entity.properties.factorySetupAt).format('MMM D YYYY, h:mm a')}</bn-property>
        <bn-property stacked label="Created At" title=${this.entity.properties.createdAt}>${moment(this.entity.properties.createdAt).format('MMM D YYYY, h:mm a')}</bn-property>
        <bn-property stacked label="Firmware Mode (Desired / Reported)">
          <device-firmware-mode .href="${this.href}" desired></device-firmware-mode>
          /
          <device-firmware-mode .href="${this.href}"></device-firmware-mode>
        </bn-property>
        <bn-property stacked label="Sleep Time (Desired / Reported)">
          <device-sleep-time .href="${this.href}" desired></device-sleep-time>
          /
          <device-sleep-time .href="${this.href}"></device-sleep-time>
        </bn-property>
      </div>
    `;
  }

  _orUnknown(value, postfix) {
    if (value === undefined) {
      return html`unknown`;
    }

    return html`${value}${renderIf(postfix, html`<span class='unit'>${postfix}</span>`)}`;
  }

  isHDDevice() {
    return this.entity?.properties.sensorType === 'hd';
  }

  isFeedDevice() {
    return ['3d', 'lidar'].includes(this.entity?.properties.sensorType);
  }
}

window.customElements.define('device-details', DeviceDetails);
